import { CustomPrefixRegistry } from '@ingka/webc-tools';
import Version from '../version.js';
const VERSION = Version.version.replace(/\./g, '-');
export default class KompisElementRegistry {
    constructor() {
        this.registry = new Map();
    }
    /**
     * Returns internal name.
     *
     * @param name Tag name.
     * @returns Internal name.
     */
    getInternalName(name) {
        return this.registry.get(name);
    }
    /**
     * Defines Kompis element.
     *
     * @param name Tag name.
     * @param elementClass Element class.
     */
    define(name, elementClass) {
        if (this.registry.has(name)) {
            return;
        }
        if (name.startsWith('skapa-')) {
            const skapaPrefix = 'skapa' + this.getSuffix();
            if (!this.passiveRegistry) {
                this.passiveRegistry = new CustomPrefixRegistry(skapaPrefix);
            }
            this.passiveRegistry.assignPrefixService(elementClass);
            this.registry.set(name, name.replace('skapa-', skapaPrefix + '-'));
            return;
        }
        // Builds tag name with suffix (e.g. "kompis-button-123-0-0")
        const newName = name + this.getSuffix();
        this.registry.set(name, newName);
        // Registers the element to the global element registry
        if (!window.customElements.get(newName)) {
            try {
                window.customElements.define(newName, elementClass);
            }
            catch (error) {
                window.customElements.define(newName, class KompisAlreadyRegisteredClassWrapper extends elementClass {
                });
            }
        }
    }
    // NB: This method is overridden in setupTests.js to allow us to remove versions from tag names in our unit tests.
    getSuffix() {
        return '-' + VERSION;
    }
}
//# sourceMappingURL=KompisElementRegistry.js.map